import ApiService from '@/core/services/api.service.js'

const SNAPSHOT_KEY='medhop_product_snapshot'
const RUNTIME_KEY='medhop_product_configuration'
const emptyConfiguration=()=>({available:false,subscription:{state:'unprovisioned'},capabilities:[],verticals:[],limits:{},experience:{primary_vertical:'general'}})

const parse=(key)=>{try{return JSON.parse(localStorage.getItem(key))}catch(e){return null}}
const emit=(configuration)=>window.dispatchEvent(new CustomEvent('medhop:product-configuration',{detail:configuration}))

const ProductConfigurationService={
  snapshot(){return parse(SNAPSHOT_KEY)},
  current(){return parse(RUNTIME_KEY)||this.snapshot()||emptyConfiguration()},
  async syncFromTenantConfig(tenantConfig){
    const snapshot=tenantConfig&&tenantConfig.product_configuration
    if(!snapshot)return null
    localStorage.setItem(SNAPSHOT_KEY,JSON.stringify(snapshot))
    try{await ApiService.post('product-configuration/sync',snapshot)}catch(error){
      // The signed snapshot remains useful for the UI while rollout/migration
      // catches up; backend capability checks still fail closed.
      console.warn('Product configuration sync pending',error&&error.response&&error.response.data)
    }
    emit(snapshot)
    return snapshot
  },
  async refresh(){
    const response=await ApiService.get('product-configuration')
    const configuration=response.data.data
    localStorage.setItem(RUNTIME_KEY,JSON.stringify(configuration))
    emit(configuration)
    return configuration
  },
  has(code){return(this.current().capabilities||[]).some(item=>(item.code||item)===code)},
  hasAny(codes){return(codes||[]).some(code=>this.has(code))},
  vertical(code){return(this.current().verticals||[]).find(item=>item.code===code)},
  label(key,fallback){
    const verticals=this.current().verticals||[]
    for(let index=verticals.length-1;index>=0;index--){const labels=verticals[index].ui_configuration&&verticals[index].ui_configuration.labels;if(labels&&labels[key])return labels[key]}
    return fallback
  },
  clear(){localStorage.removeItem(SNAPSHOT_KEY);localStorage.removeItem(RUNTIME_KEY);emit(emptyConfiguration())}
}

export default ProductConfigurationService
